import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Page from "components/Page";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Col,
  Row,
  Button,
  CardGroup,
  CardHeader
} from 'reactstrap';
import { IconWidget } from 'components/Widget';
import {

  MdRateReview,
  MdThumbUp,
} from 'react-icons/lib/md';
import { R_OK } from "constants";

import { fetchListarCotizadores } from "../../redux/actions/aRamoLineaFinanciera";
import { ambienteAplicacion } from '../../constants/urls'

class Cotizadores extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onClickHogar = this.onClickHogar.bind(this);
    this.onClickLineaFinanciera = this.onClickLineaFinanciera.bind(this);
    this.onClickAPG = this.onClickAPG.bind(this);
    this.onClickAP = this.onClickAP.bind(this);

  }

  onClick(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion",
      search: "?accion=nuevo"
    });
  }
  onClickHogar(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion-hogar-datospersonales",
    });
  }

  onClickAPG(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion-accidente",
    });
  }

  onClickAP(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion-accidente-personal",
    });
  }

  onClickLineaFinanciera = params => {
    const { idProducto } = params;
    if (idProducto <= 121) {
      this.props.history.replace({
        pathname: "/cotizacion-financiero",
        search: `?idProducto=${idProducto}`
      });
    }else if (idProducto === 124) {
      this.props.history.push({
        pathname: "/rc-andina/cotizador",
        //ssearch: ``
      });
    }
    else{
      this.props.history.replace({
        pathname: "/cotizacion-responsabilidad",
        search: `?idProducto=${idProducto}`
      });
    }
  }
  async componentDidMount() {
    await this.props.listarCotizadores(ambienteAplicacion);
  }

  render() {
    return (
      <Page title="Cotizadores" breadcrumbs={[{ name: "cotizadores", active: true }]}>
        <Row>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Card>
              <CardHeader>Vehículos</CardHeader>
              <CardBody>
                <div className="media">
                  <Row>
                    <Col lg={9} md={12} sm={12} xs={12}>
                      <div className="overflow-hidden media-body">
                        <h4 className="text-truncate media-heading">Seguro de Vehículos</h4>
                        <p className="text-muted descripcion-cotizadores">Seguro para vehículos motorizados de uso particular privado con cobertura “todo riesgo”, que protege el vehículo contra cualquier eventualidad relacionada con: daños propios, daños a terceros (lesiones o daños materiales), lesiones a ocupantes del vehículo, servicios y beneficios adicionales.</p>
                      </div>
                    </Col>
                    <Col lg={3} md={12} sm={12} xs={12}>
                      <div className="alinear-width-heigth">
                        <Button className="btn btn-primary" onClick={this.onClick} > COTIZAR </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <hr></hr>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>HOGAR</CardHeader>
              <CardBody>
                <div className="media">
                  <Row>
                    <Col lg={9} md={12} sm={12} xs={12}>
                      <div className="overflow-hidden media-body">
                        <h4 className="text-truncate media-heading">Seguro de Hogar</h4>
                        <p className="text-muted descripcion-cotizadores">El Seguro de Hogar es una póliza multiriesgo que ampara tanto el contenido y/o la estructura del inmueble contra cualquier eventualidad a través de planes cerrados o abiertos. Adicionalmente, se puede cubrir daños en equipos eléctricos y electrónicos, accidentes personales para el personal doméstico y responsabilidad civil.</p>
                      </div>
                    </Col>
                    <Col lg={3} md={12} sm={12} xs={12}>
                      <div className="alinear-width-heigth">
                        <Button
                          className="btn btn-primary"
                          onClick={this.onClickHogar}
                        >
                          COTIZAR
                            </Button>
                      </div>
                    </Col>
                  </Row>


                </div>
                <hr></hr>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>Pymes</CardHeader>
              <CardBody>
                <div className="media">
                  <Row>
                    <Col lg={9} md={12} sm={12} xs={12}>
                      <div className="overflow-hidden media-body">
                        <h4 className="text-truncate media-heading">Seguro de Pymes</h4>
                        <p className="text-muted descripcion-cotizadores">Las soluciones de seguros de PYMES que ofrece AIG están orientadas a proteger el patrimonio de empresarios y emprendedores que han invertido el esfuerzo de toda una vida para montar su negocio. El tenerlo asegurado ayudará a mantener su operación en caso de siniestro.</p>
                      </div>
                    </Col>
                    <Col lg={3} md={12} sm={12} xs={12}>
                      <div className="alinear-width-heigth">
                        <Button className="btn btn-primary" onClick={() => this.props.history.push({ pathname: "/pymes/cotizador", search: "?paso=1" })} > COTIZAR </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <hr></hr>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>ACCIDENTES PERSONALES</CardHeader>
              <CardBody>
                <div className="media">
                  <Row>
                    <Col lg={9} md={12} sm={12} xs={12}>
                      <div className="overflow-hidden media-body">
                        <h4 className="text-truncate media-heading">Seguro de Asistencia en Viaje AIG Travel Guard</h4>
                        <p className="text-muted descripcion-cotizadores">El Seguro de Asistencia en Viaje AIG Travel Guard provee cobertura con asistencia médica, jurídica y personal en 160 países a nivel mundial, las 24 horas del día, los 365 días del año, para accidentes y situaciones imprevistas que se puedan presentar durante el viaje. </p>
                      </div>
                    </Col>
                    <Col lg={3} md={12} sm={12} xs={12}>
                      <div className="alinear-width-heigth">
                        <Button
                          className="btn btn-primary"
                          onClick={this.onClickAPG}
                        >
                          COTIZAR
                            </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <hr></hr>

                <div className="media">
                <Row>
                    <Col lg={9} md={12} sm={12} xs={12}>
                      <div className="overflow-hidden media-body">
                        <h4 className="text-truncate media-heading">Accidentes personales</h4>
                        <p className="text-muted descripcion-cotizadores">El seguro de Accidentes Personales cubre las lesiones corporales ocasionadas por cualquier tipo de accidente, en cualquier parte del mundo, las veinticuatro (24) horas del día, los trescientos sesenta y cinco (365) días del año, inclusive cuando el Asegurado esté viajando como pasajero no como piloto o tripulante, en un avión comercial.</p>
                      </div>
                    </Col>
                    <Col lg={3} md={12} sm={12} xs={12}>
                      <div className="alinear-width-heigth">
                        <Button
                          className="btn btn-primary"
                          onClick={this.onClickAP}
                        >
                          COTIZAR
                            </Button>
                      </div>
                    </Col>
                  </Row>

                </div>

              </CardBody>
            </Card>


          </Col>


          <Col lg={6} md={6} sm={12} xs={12}>
            <Row>
            <Card>
              <CardHeader>LÍNEAS FINANCIERAS</CardHeader>
              <CardBody>
                {this.props.datosListarCotizadores !== undefined && Object.keys(this.props.datosListarCotizadores).length > 0 &&
                  this.props.datosListarCotizadores.map((cotizador, i) => {
                    return (
                      <div key={'cotizadorfinaciera' + i}>
                        {console.log(cotizador) }
                        <div>
                          <Row>
                            <Col lg={9} md={12} sm={12} xs={12}>
                              <div className="overflow-hidden media-body">
                                <h4 className="text-truncate media-heading">{cotizador.segNombre}</h4>
                                <p className="text-muted descripcion-cotizadores">{cotizador.segDescripcion}</p>
                              </div>
                            </Col>
                            <Col lg={3} md={12} sm={12} xs={12}>
                              <div className="alinear-width-heigth">
                                <Button
                                  className="btn btn-primary"
                                  onClick={() => { this.onClickLineaFinanciera({ idProducto: cotizador.segCodigoCore }) }}
                                >
                                  COTIZAR
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <hr></hr>
                      </div>
                    );
                  })
                }
              </CardBody>
            </Card>
            </Row>


          </Col>
        </Row>


      </Page>

    );
  }
}

const mapStateToProps = state => ({
  datosListarCotizadores: state.datosListarCotizadores.listarCotizadores
});
const mapDispatchToProps = dispatch => {
  return {
    listarCotizadores: (datos) => dispatch(fetchListarCotizadores(datos)),
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Cotizadores)
);
